import { foot, px, type WorldObject } from './mapdef';

/** Interactive objects of the family package (ids prefixed, see mapdef ObjectId). */
export const PLOT_TILES: readonly [number, number][] = Array.from({ length: 9 }, (_, i) => [5 + (i % 3) * 2, 4 + Math.floor(i / 3) * 2]);

export const OBJECTS_FAMILY: readonly WorldObject[] = [
  ...PLOT_TILES.map(([tx, ty], i): WorldObject => ({
    id: `fam_plot${i}`,
    map: 'balcony',
    rect: { x: px(tx) + 1, y: px(ty) + 4, w: px(2) - 2, h: 12 },
    solid: true,
    label: 'fam_plot',
    icon: '🌱',
    tall: 24,
  })),
  { id: 'fam_tap', map: 'balcony', rect: foot(1, 6, 1, 9, 1), solid: true, label: 'fam_tap', icon: '🚰' },
];
